var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.711914 3.76325L13.0526 3.76325M13.0526 3.76325C13.0526 5.44843 14.4339 6.81453 16.1378 6.81453C17.8417 6.81453 19.223 5.44843 19.223 3.76325C19.223 2.07808 17.8417 0.711975 16.1378 0.711975C14.4339 0.711975 13.0526 2.07808 13.0526 3.76325ZM6.88227 11.9L19.223 11.9M6.88227 11.9C6.88227 13.5852 5.50099 14.9513 3.79709 14.9513C2.0932 14.9513 0.711914 13.5852 0.711914 11.9C0.711914 10.2148 2.0932 8.84871 3.79709 8.84871C5.50099 8.84871 6.88227 10.2148 6.88227 11.9Z",
    stroke: "white",
    strokeWidth: 1.42393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.3e42561622a26cf759b4ab8c139c4965.svg";
export { ForwardRef as ReactComponent };